import { useMemo } from 'react';

import { useAppBreadcrumb, useAppRouter } from '@/common/hooks';
import { AppRouterTypes } from '@/common/interfaces';

export const useCurrentRouteType = (): { routeType: AppRouterTypes } => {
  const {
    routes: { drawer: drawerRoutes }
  } = useAppRouter();

  const { breadcrumb } = useAppBreadcrumb();

  const routeType = useMemo(
    () =>
      Array.from(new Set(drawerRoutes.filter((el) => el.path !== '*').flatMap(
        el => 'children' in el ? [el.children?.flatMap(chEl => chEl.path), el.path].flat() : el.path
      ))).includes((breadcrumb.at(-1)?.match.route?.path ?? ''))
        ? AppRouterTypes.Drawer
        : AppRouterTypes.Common,
    [breadcrumb, drawerRoutes]
  );

  return { routeType };
};
